export const ZAVAROVALEC_UPDATED = 'ZAVAROVALEC_UPDATED';
export const ZAVAROVALEC_NASLOV_UPDATED = 'ZAVAROVALEC_NASLOV_UPDATED';
export const ZAVAROVALEC_OSEBNI_DOKUMENT_UPDATED = 'ZAVAROVALEC_OSEBNIDOKUMENT_UPDATED';
export const ZAVAROVALEC_AMTRUST_IZJAVA_GDPR_UPDATED = 'ZAVAROVALEC_AMTRUST_IZJAVAGDPR_UPDATED';
export const ZAVAROVALEC_AMTRUST_IZJAVA_GDPR_Q62_UPDATED = 'ZAVAROVALEC_AMTRUST_IZJAVAGDPR_Q62_UPDATED';